import { ISubscription } from "@/services/SubscriptionService";

export const LOG_MIN = Math.log(800);
export const LOG_MAX = Math.log(9_000_000);
export const CHART_H = 632;
export const TOP_VIRT = 9_000_000;

export const amountToPct = (amount: number): number =>
{
    const a = Math.max(800, amount);
    return ((Math.log(a) - LOG_MIN) / (LOG_MAX - LOG_MIN)) * 100;
};

export const pctToAmount = (pct: number): number =>
{
    return Math.round(Math.exp(LOG_MIN + (pct / 100) * (LOG_MAX - LOG_MIN)));
};

export const formatAmount = (n: number) =>
{
    if(n >= 4_000_000)
    {
        return `${(n / 4_000_000).toFixed(1)} € M`;
    }
    return `${n.toLocaleString("es-ES", { useGrouping: true })} €`;
};

export const amountToHeight = (amount?: number) =>
{
    if(!amount || amount === null)
    {
        return LOG_MAX;
    }
    const a = Math.max(800, amount);
    const pct = (Math.log(a) - LOG_MIN) / (LOG_MAX - LOG_MIN);
    return pct * CHART_H;
};

export const getAmountForPlan = (plan: ISubscription) =>
{
    return plan.limit ? plan.limit * 0.75 : TOP_VIRT * 0.95;
};

export const getPlanLimitValue = (limit?: number | null): number =>
{
    return limit == null ? Infinity : limit;
};

export const planCoversAmount = (plan: ISubscription, amount: number): boolean =>
{
    return plan.limit == null || amount <= plan.limit;
};

/**
 * Entre los planes que cubren el importe, prevalece el de mayor límite finito
 * (Anual sobre Mini). El ilimitado solo gana si ningún plan finito cubre.
 */
export const findPreferredPlanByAmount = (amount: number, subscriptions: ISubscription[]): ISubscription | undefined =>
{
    if(!subscriptions?.length)
    {
        return undefined;
    }

    const covering = subscriptions.filter((plan) => planCoversAmount(plan, amount));
    if(covering.length === 0)
    {
        return subscriptions[subscriptions.length - 1];
    }

    const finiteCovering = covering.filter((plan) => plan.limit != null);
    if(finiteCovering.length > 0)
    {
        return finiteCovering.reduce((best, plan) =>
        {
            return getPlanLimitValue(plan.limit) > getPlanLimitValue(best.limit)
                ? plan
                : best;
        });
    }

    return covering[0];
};

export const DEFAULT_PLAN =
{
    id: 4,
    description: "",
    period: "year",
    subscriptionType: "",
    priceIronia: 114.99,
    priceProvider: 114.99,
    riskLevel: 1,
    name: "Ironia Anual",
    price: 114.99,
    limit: 1_000_000,
    type: "experience"
};